export default function Logo({className = ""}: {className?: string}) {
    return (<svg xmlns="http://www.w3.org/2000/svg"
                 viewBox="0 0 1024 1024"
                 className={`${className} icon`}>
        <path
            d="M830 582c1 19-1 38-16 53a413 413 0 0 1-579 48c-23-18-26-41-25-67 7-40 39-50 71-61 15-5 30-6 46-3 30 8 47 28 52 58 12 66 11 67 70 76-20-1-48-10-52-44-6-44 24-68 58-87 18-7 38-9 58-8 12 1 25 4 36 7 62 27 125 24 190 15 31-4 63-13 91 13Z"
            style={{fill: "#fcfbf9"}}/>
        <path
            d="m328 564-39 4c-37 9-65 0-76-41-5-34-54-74 12-101 6-5 13-8 21-11 24-6 47-3 71 2 44 13 90 5 135 9 19 1 40 2 55 15 45 37 68 16 82-30 26-19 55-17 85-14 57 12 59 55 51 99-11 52-48 80-101 83-30 2-59-6-89-11l-15-3c-7-2-15-3-21-8-44-41-88-41-130 3-14 6-28-4-41 4Z"
            style={{fill: "#1d1f1e"}}/>
        <path
            d="m238 428-7 2-6-4c6-41 24-73 66-87 63-32 125-69 201-39l4-3-1-7c39-22 80-11 121-7 21 23 58 25 76 54 14 31 52 70-25 69-57-17-110-2-160 25-13 6-27 4-40 11l-148-7c3-14 18-14 26-24-40-16-74 0-107 17Z"
            style={{fill: "#fad151"}}/>
        <path
            d="M666 400c76-7 8-40 11-60 7-9 17-12 29-12 11 2 20 6 29 12 28 13 58 24 65 60 47 54 30 119 30 182-92 8-184 32-276-2-7-3-13-8-19-12 54 2 110 9 153-36 42-45 31-106-23-123l1-9Z"
            style={{fill: "#fac41a"}}/>
        <path
            d="M222 607c13 106 110 113 180 137 157 53 288-24 412-109l-27 68c-58 28-98 83-165 99-128 30-248 30-357-55-38-55-103-101-57-182 17 10 9 28 14 42Z"
            style={{fill: "#e1d7c8"}}/>
        <path
            d="m708 339-31 1c-21-11-37-28-63-33-35-5 6-15 2-24 24-21 48-44 74-64 23-17 49-43 80-27 30 15 26 51 28 80 3 42 1 85 2 128-16-31-55-24-76-46 11-20 14-40 5-62-27 8-9 34-21 47Z"
            style={{fill: "#f0b125"}}/>
        <path
            d="M265 747c103 58 212 71 327 44 46-11 90-26 128-60 17-14 34-44 67-28-110 158-327 160-468 92-22-11-48-19-54-48Z"
            style={{fill: "#cebc9d"}}/>
        <path
            d="M495 290c10 5 32 26 3 17-77-23-136 36-207 32l7-14c15-39-6-100 28-117 38-18 57 45 90 63 23 12 52 13 79 19Z"
            style={{fill: "#ebac35"}}/>
        <path d="M222 607c-18-10-7-29-14-42l5-38c21 21 46 36 76 41-19 19-53 11-67 39Z" style={{fill: "#e0b839"}}/>
        <path
            d="M328 564c9-12 21-13 34-12 28 4 60-14 84 14 8 38-76 43-34 90 33 38 73 2 130-4-39 48-75 55-116 48-19-3-35-21-57-14-14 5-32 11-39-6-11-23 18-16 24-25 26-39 13-69-26-91Z"
            style={{fill: "#6f562e"}}/>
        <path d="M446 566c-27-12-59 11-83-14 61-97 109-42 157 13l-74 1Z" style={{fill: "#deb73b"}}/>
        <path d="M238 428c56-61 90-62 143-7-18 20-42 6-62 14l-81-7Z" style={{fill: "#ebe0a3"}}/>
        <path d="M666 400c-2 3-3 6-1 9l-78 21c-30 24-60 20-89-1 47-59 105-58 168-29Z" style={{fill: "#f9efae"}}/>
        <path d="m498 429 89 1c6 14 47 27-3 42-47 15-83 1-117-30l31-13Z" style={{fill: "#424844"}}/>
        <path d="M708 339c-35-24-26-47 2-70 12-8 32-25 36-8 8 31 32 74-22 93l-16-15Z" style={{fill: "#dd9427"}}/>
    </svg>);
}